import { render, staticRenderFns } from "./TabFinished.vue?vue&type=template&id=5848ffc0&scoped=true&"
import script from "./TabFinished.vue?vue&type=script&lang=js&"
export * from "./TabFinished.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5848ffc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5848ffc0')) {
      api.createRecord('5848ffc0', component.options)
    } else {
      api.reload('5848ffc0', component.options)
    }
    module.hot.accept("./TabFinished.vue?vue&type=template&id=5848ffc0&scoped=true&", function () {
      api.rerender('5848ffc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocr/components/TabFinished.vue"
export default component.exports